import { SecondaryFilterProps } from "@mcleod/dispatch";
import { ModelRow } from "@mcleod/core";

export class CommissionsProcessingTaskFilter {
    static readonly ORDER_BILLED: SecondaryFilterProps = {
        id: "orderBilled",
        caption: "Order Billed",
        filter: (row: ModelRow) => {
            return !row.isNull("orders.bill_date");
        }
    }

    static readonly OVERRIDE_RATE: SecondaryFilterProps = {
        id: "overrideRate",
        caption: "Override Rate",
        filter: (row: ModelRow) => {
            return row.getBoolean("override_rate", false);
        }
    };
}
